import { trackPromise } from "react-promise-tracker";
import { PointLocation } from "../data/LockerDataTypes";
import { IMapCenter } from "../data/MapCenter";
import { isObjectNullOrEmpty } from "../services/lockerService";
import { Api } from "../utils/Api";

export class CityMapCenter implements IMapCenter {
    value: any;
    order: number;

    constructor(value: any, order: number) {
        this.value = value;
        this.order = order;
    }

    IsApplicable(): boolean {
        return isObjectNullOrEmpty(this.value) === false
            && isObjectNullOrEmpty(this.value.city) === false;
    };

    async Run(): Promise<PointLocation> {
        return await trackPromise(Api.Get().GetMapCenterCoordinates(this.value.city, this.value.county, this.value.countryCode).then(res => {
            return res;
        }));
    };
}